import React from 'react';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const MonthYearSelector = ({ month, year, setMonth, setYear, sx }) => {
  const { t } = useTranslation();
  const value = dayjs(`${year}-${String(month).padStart(2, '0')}-01`);

  const handleChange = (newValue) => {
    if (!newValue) return;
    setMonth(newValue.month() + 1); // months: 0–11
    setYear(newValue.year());
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['year', 'month']}
        label={t('select_month_year')}
        value={value}
        onChange={handleChange}
        disableFuture
        slotProps={{
          textField: {
            size: 'small',
            variant: 'outlined',
            sx,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default MonthYearSelector;
